module.exports = __webpack_public_path__ + "img/guide_bg.b40c0165.png";